export const locale = {
    lang: 'en',
    data: {
        TOOLBAR: {
            TITLES: {
                SALES: 'Sales',
                RENTALS: 'Rentals',
                BUILDINGS: 'Buildings',
                SEARCH: 'Search',
                PROPERTIES: 'Properties',
                BROWSE_SALE_LISTINGS: 'Browse sale listings',
                VISUAL_LOOKBOOK: 'Visual lookbook',
                UPLOAD_PHOTOS_FOR_SIMILAR: 'Upload photos to find similar properties',
                PERSONA_MATCHING: 'Persona matching',
                EXPLORE_PSYCHOGRAPHIC_SEARCH_OPTIONS: 'Explore psychographic search options',
                RESOURCES: 'Resources',
                COMPARABLES: 'Comparables',
                FIND_SALES_COMPS: 'Find sales comps',
                BROWSE_RENTAL_LISTINGS: 'Browse rental listings',
                FIND_RENTALS_COMPS: 'Find rentals comps',
                BUILDING_DIRECTORY: 'Building directory',
                SEARCH_BUILDINGS_CONDOS: 'Search buildings and condos',
                NEIGHBORHOODS_GUIDE: 'Neighborhood guide',
                EXPLORE_NYC_NEIGHBORHOODS: 'Explore NYC neighborhoods',
                MARKET_ACTIVITY: 'Market Activity',
                ANALYTICS: 'Analytics',
                AGENT_HUB: 'Agent Hub',
                OVERVIEW: 'Overview',
                MY_LISTINGS: 'My listings',
                MY_PORTFOLIO: 'My portfolio',
                ACTIVITY: 'Activity',
                PREFERENCES: 'Preferences',
                ACCOUNT_SETTINGS: 'Account settings',
                KNOWLEDGE_BASE: 'Knowledge base',
                FEATURE_FLAGS: 'Feature Flags',
                DESIGN_LAB: 'Design Lab',
                LOG_OUT: 'Log Out',
                NOTIFICATIONS: 'Notifications',
                DARK_MODE: 'Enable Dark Mode',
                LIGHT_MODE: 'Enable Light Mode',
                NORMAL_MODE: 'Enable Normal Mode',
                CONTRAST_MODE: 'Enable Contrast Mode',

                PROFILE: 'My Profile',
                LOGIN: 'Login',
                MY_REPORTS: 'My Reports',
            },
        }
    }
};